import { TrainingLinkDataType } from "../components/organisms/header";
import { createRequestAtom } from "../utils/request-atom";

export const trainingLinkAtom = createRequestAtom<TrainingLinkDataType>();